import router from '@/router'

router.afterEach((to) => {
  // 页面标题
  document.title = to.meta.title || ''
})
